import { UserMessageCreateParams, FileMessageCreateParams } from '@sendbird/chat'

/**
 * @typedef {import('@sendbird/chat').UserMessageCreateParams} UserMessageCreateParams
 */

/**
 * @param {string} input
 * @param {string} jsonVerificationToken
 * @returns {UserMessageCreateParams}
 */
export const getMsgParams = (input, jsonVerificationToken) => {
  /** @type {UserMessageCreateParams} */
  return {
    message: input,
    customType: 'V1.TXT',
    data: jsonVerificationToken,
  }
}

/**
 * @typedef {import('@sendbird/chat').FileMessageCreateParams} FileMessageCreateParams
 */

/**
 * @param {File} file
 * @param {string} jsonVerificationToken
 * @returns {FileMessageCreateParams}
 */
export const getImgParams = (file, jsonVerificationToken) => {
  /** @type {FileMessageCreateParams} */
  return {
    file: file,
    customType: 'V1.IMG',
    mimeType: file.type,
    thumbnailSizes: [{ maxWidth: 600, maxHeight: 600 }],
    data: jsonVerificationToken,
  }
}

/**
 * @param {File} file
 * @param {string} jsonVerificationToken
 * @returns {FileMessageCreateParams}
 */
export const getFileParams = (file, jsonVerificationToken) => {
  /** @type {FileMessageCreateParams} */
  return {
    file: file,
    customType: 'V1.FILE',
    mimeType: file.type,
    data: jsonVerificationToken,
  }
}

// if we will send in location in the future, this is the format:
// of course use the input instead of the hardcoded data.
/*
export const getMsgParamsLocation = () => {
  const data = {
    lat: 59.332254,
    lon: 18.052765,
    address: 'Västra Järnvägsgatan 23 - Västra Järnvägsgatan 23, 111 64 Stockholm, Sverige',
  }

  const msgParamsLocation = new sendBird.UserMessageParams()
  msgParamsLocation.message = 'Västra Järnvägsgatan 23, 111 64 Stockholm, Sverige'
  msgParamsLocation.data = JSON.stringify(data)
  msgParamsLocation.customType = 'V1.LOCATION'

  return msgParamsLocation
}
*/

// This is how the Extension data will look like (for example Blocket Betalning):
/*
export const getMsgParamsExtension = () => {

  const data = {
    data: {
      extensionName: 'se.blocket.payments.p2p',
      completed: true,
      users: [
        {
          userId: 'f35fc259-7a8c-43ec-87bb-7a4d4d3fe071',
          content: {
            header: 'Blocketbetalning',
            text: 'Betalningsuppdrag från Åke Vilse',
            text2: 'Att betala: 90 000 kr.',
            imageUrl: 'https://www.blocket.se/moneyImage.png',
            link: 'https://www.erdetfredag.dk',
            label: 'Läs mer här',
          },
          actions: [
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'CTA',
            },
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'Primary',
            },
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'Secondary', // this is the default if `type` is empty
            },
          ],
        },
        {
          userId: '3b28b2b0-4b2b-4dca-96eb-73e2a347b755',
          content: {
            header: 'Blocketbetalning',
            text: 'Betalningsuppdrag från Åke Vilse',
            text2: 'Att betala: 90 000 kr.',
            imageUrl: 'https://www.blocket.se/moneyImage.png',
            link: 'https://www.erdetfredag.dk',
            label: 'Läs mer här',
          },
          actions: [
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'CTA',
            },
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'Primary',
            },
            {
              label: 'Gå till betalning',
              url: 'https://www.erdetfredag.dk',
              type: 'Secondary', // this is the default if `type` is empty
            },
          ],
        },
      ],
    },
  }

  const msgParamsExtension = new sendBird.UserMessageParams()
  msgParamsExtension.data = JSON.stringify(data)
  msgParamsExtension.message = 'this is an extension'
  msgParamsExtension.customType = 'V1.EXTENSION'

  return msgParamsExtension
}
*/
